import { LayerSpecification } from "@iventis/mapbox-gl";
import { MAPBOX_MAX_ZOOM, MAPBOX_MIN_ZOOM } from "../../../constants";

export const updateLayerDynamicStyling = (layer: LayerSpecification, buildings3d: boolean, streetNames: boolean): LayerSpecification => {
    // Clone the layer to avoid mutating the original cached layer spec
    const clonedLayer = JSON.parse(JSON.stringify(layer)) as LayerSpecification;

    // Check the fill-extrusion first and disable if 3dbuildings is off
    if (buildings3d === false && clonedLayer.type === "fill-extrusion") {
        clonedLayer.layout = { ...clonedLayer.layout, visibility: "none" };
    }

    // Hide or show 2d areas in their place
    if (buildings3d === false && clonedLayer.type === "fill") {
        clonedLayer.maxzoom = MAPBOX_MAX_ZOOM;
        clonedLayer.minzoom = clonedLayer?.minzoom ?? MAPBOX_MIN_ZOOM;
    }

    if (streetNames === false && clonedLayer.type === "symbol") {
        clonedLayer.layout = { ...clonedLayer.layout, visibility: "none" };
    }
    return clonedLayer;
};
